import { useSearchParams } from "react-router-dom"

import Style from "./style"
import rangeCalculator from "./lib/rangeCalculator"
import usePagenation from "./model/usePagenation"

import previousActiveIIcon from "./asset/left_black.svg"
import preciousDeactiveIcon from "./asset/left_grey.svg"
import nextActiveIcon from "./asset/right_black.svg"
import nextDeactiveIcon from "./asset/right_grey.svg"

const Pagenation = ({ maxPage, prefix = "" }) => {
    const [searchParam] = useSearchParams()
    const getParamName = (paramName) => prefix ? `${prefix}_${paramName}` : paramName

    const nowPage = searchParam.get(getParamName("page")) || 1

    const range = rangeCalculator(nowPage, maxPage)
    const [prePageEvent, movePageEvent, nextPageEvent] = usePagenation(nowPage, maxPage, prefix)

    return (
        <Style.Wrapper>

            <Style.MoveBtn $active={nowPage > 1} onClick={prePageEvent}>
                <img src={nowPage > 1 ? previousActiveIIcon : preciousDeactiveIcon} /> 이전
            </Style.MoveBtn>

            <Style.PageBtnWrapper>
                {range?.map((elem) =>
                    <Style.PageBtn 
                        key={elem} 
                        $active={parseInt(nowPage) === elem} 
                        onClick={() => movePageEvent(elem)}>{elem}
                    </Style.PageBtn>
                )}
            </Style.PageBtnWrapper>

            <Style.MoveBtn $active={nowPage < maxPage} onClick={nextPageEvent}>
                다음 <img src={nowPage < maxPage ? nextActiveIcon : nextDeactiveIcon} />
            </Style.MoveBtn>

        </Style.Wrapper>
    )
}

export default Pagenation